import produce from 'immer';
import {
  GET_CMS_BLOCK_BY_IDENTIFIER_START,
  GET_CMS_BLOCK_BY_IDENTIFIER_SUCCESS,
  GET_CMS_BLOCK_BY_IDENTIFIER_FAILED
} from '../actions/cms_blocks';


const initialState = {
  cmsBlock: [],
  loadingCmsBlock: false
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case GET_CMS_BLOCK_BY_IDENTIFIER_START: {
      state.loadingCmsBlock = true;
      break;
    }
    case GET_CMS_BLOCK_BY_IDENTIFIER_SUCCESS: {
      const {data} = action;

      if (data.total_count === 1) {
        // eslint-disable-next-line prefer-destructuring
        state.cmsBlock = data.items[0];
      }

      state.loadingCmsBlock = false;

      break;
    }
    case GET_CMS_BLOCK_BY_IDENTIFIER_FAILED: {
      state.loadingCmsBlock = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
